<template>
    <div class="module-empty science"></div>
</template>

<script>
export default {
    name: 'DiseaseScience',
};
</script>
